<% for (const instruction of instructions) { %>
<div class="form-control mb-3 p-2">
	<div>
		<strong><%= Anvil.moment(instruction.insert_dt).format('YYYY.MM.DD HH:mm:ss') %></strong>
		<% if (instruction.sent_dt) { %>
			<div class="badge bg-success float-end">Kézbesítve</div>
		<% } else { %>
			<div class="badge bg-warning text-dark float-end">Feladva</div>
		<% } %>
	</div>
	<hr class="mt-1 mb-2" />
	<pre style="white-space:pre-wrap; word-break:break-word; background-color:transparent; border:none; padding:0; margin:0; tab-size:4;"><%- instruction.instruction %></pre>
</div>
<% } %>